import { required, maxLength, range, nested,table, property, alpha, alphaNumeric, numeric, uppercase,pattern,minDate,maxNumber,maxDate,lowercase,hexColor,email,contains,compare } from '@rx/annotations';
@table('vUserMessageMapping')
export class vUserMessageMapping {
    constructor(vUserMessageMapping?: vUserMessageMapping )  {
        let properties = [ "callTypeId", "createdById", "createdDateTime", "isForward", "isRead", "message", "messageId", "messageTransactionLogId", "messageType", "modifiedById", "modifiedDateTime", "notificationCount", "notificationMessage", "notificationSendTime", "optionalMessage", "patientName", "practiceId", "senderMessageTransactionLogId", "skey", "userId", "userMessageMappingId",];
        for (let property of properties)
            if (vUserMessageMapping && (vUserMessageMapping[property] || vUserMessageMapping[property] == 0))
                this[property] = vUserMessageMapping[property];
    }
 
	@property('CallTypeId')
	callTypeId : number =   undefined;
 
    @range(1,2147483647)
	@property('CreatedById')
	createdById : number =   undefined;
 
    @required()
	@property('CreatedDateTime')
	createdDateTime : Date =   undefined;
 
	@property('IsForward')
	isForward : boolean = false ;
 
	@property('IsRead')
	isRead : boolean = false ;
 
    @required()
	@property('Message')
	message : string = undefined ;
 
    @range(1,2147483647)
	@property('MessageId')
	messageId : number =   undefined;
 
	@property('MessageTransactionLogId')
	messageTransactionLogId : number =   undefined;
 
    @range(1,2147483647)
	@property('MessageType')
	messageType : number =   undefined;
 
	@property('ModifiedById')
	modifiedById : number =   undefined;
 
	@property('ModifiedDateTime')
	modifiedDateTime : Date =   undefined;
 
    @range(1,2147483647)
	@property('NotificationCount')
	notificationCount : number =   undefined;
 
    @required()
	@property('NotificationMessage')
	notificationMessage : string = undefined ;
 
    @required()
	@property('NotificationSendTime')
	notificationSendTime : Date =   undefined;
 
    @maxLength(200)
	@property('OptionalMessage')
	optionalMessage : string = undefined ;
 
    @required()
    @maxLength(50)
	@property('PatientName')
	patientName : string = undefined ;
 
    @range(1,2147483647)
	@property('PracticeId')
	practiceId : number =   undefined;
 
	@property('SenderMessageTransactionLogId')
	senderMessageTransactionLogId : number =   undefined;
 
    @range(1,2147483647)
	@property('Skey')
	skey : number =   undefined;
 
    @range(1,2147483647)
	@property('UserId')
	userId : number =   undefined;
 
    @range(1,2147483647)
	@property('UserMessageMappingId')
	userMessageMappingId : number =   undefined;



}
